<template>
  <modal
    ref="modal"
    body-class="p-0 d-flex flex-column"
    :width="1200"
    @close-modal="$emit('close')"
  >

    <!-- Modal Header -->
    <template #header>
      <h5 class="d-flex align-items-center">
        DevTools

        <span class="ml-2 font-weight-light">| Debugging</span>

      </h5>
    </template>

    <!-- Modal Body -->
    <template #body>

      <!--      <div class="row no-gutters">-->
      <!--        &lt;!&ndash; Left Group &ndash;&gt;-->
      <!--        <div class="col p-3">-->
      <!--          <form>-->
      <!--            <div class="form-group">-->
      <!--              <label for="exampleFormControlTextarea1">Comment Text</label>-->
      <!--              <textarea class="form-control" v-model="text" id="exampleFormControlTextarea1" rows="3"></textarea>-->
      <!--            </div>-->
      <!--          </form>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="row no-gutters">
        <div class="col p-3">

          <div class="card" style="width: auto;">
            <div class="card-body">
              <h5 class="card-title">Authentication</h5>
              <h6 class="card-subtitle mb-2 text-body-secondary">Card subtitle</h6>
              <p class="card-text">Access Token: {{ accessToken }}</p>
              <p class="card-text">refreshToken: {{ refreshToken }}</p>
              <p class="card-text">expiresAt: {{ expiresAt }}</p>

              <a href="#" @click="invalidateAccessToken" class="card-link">Invalidate Token</a>
              <a href="#" @click="checkIfTokenNeedsRefresh" class="card-link">Test Token Expiry</a>
              <a href="#" @click="clearLocalForage" class="card-link">Clear LocalForage</a>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <p>Col1</p>
              <p>Col2</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <button
                type="submit"
                class="btn btn-primary btn-sm ml-auto"
                @click="console.log('wheee')"
              >Test A
              </button>
            </div>
          </div>

        </div>
        <div class="col p-3">
          COL2
        </div>

      </div>

    </template>
    <template #footer>
      <div
        class="form-group m-0 d-flex"
        :class="{ 'flex-fill': !false }"
      >

        <button
          type="submit"
          class="btn btn-primary btn-sm ml-auto"
          @click="submit()"
        >
          Submit
        </button>


      </div>
    </template>
  </modal>
</template>

<script>

import { mapState } from "vuex"
import { localForageAuthService } from "../../../store/plugins/LocalForageAuthService"

export default {

  components: {},
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  emits: ["submit", "close"],

  data() {
    return {
      text: "",
    }
  },

  computed: {
    ...mapState('auth', {
      user: 'user',
      accessToken: 'access_token',
      refreshToken: 'refresh_token',
      expiresAt: 'expires_at',
    }),
    textLength() {
      return this.lodash.get(this, 'text', "").length;
    },
  },

  watch: {
    text: function (newVal) {
      //
    },
  },

  beforeMount() {
    this.init()
  },

  methods: {
    async init() {},

    invalidateAccessToken() {
      console.log("INVALIDATE TOKEN")

      this.$store.dispatch('auth/setAuthenticationData', {
        access_token: null,
        expires_at: null,
        persist: null,
      }).then(() => {
        this.$store.dispatch("auth/attemptTokenRefresh").then((result) => {
          console.log("---- Attempt Token Refresh Result ----")
          console.log(result)
        })
      })
    },

    checkIfTokenNeedsRefresh() {
      this.$store.dispatch('auth/tokenNeedsRefresh').then(function(res) {
        console.log("Token needs refresh result")
        console.log(res)
      })


    },

    async clearLocalForage() {
      const lfAccessToken = await localForageAuthService.getItem('auth.access_token');
      const lfExpiresAt   = await localForageAuthService.getItem('auth.expires_at');
      const lfPersist     = await localForageAuthService.getItem('auth.persist');

      console.log('lfAccessToken: ' + lfAccessToken);
      console.log('lfExpiresAt: ' + lfExpiresAt);
      console.log('lfPersist: ' + lfPersist);

      // localForageAuthService.clear();

    },

    // submit() {
    //   console.log("==== COMMENT SUBMITTED ====", "Value: " + this.text)
    //   this.$emit("submit", this.text)
    // }
  }
}
</script>

<style>
.modal-body.fixed-height {
  min-height: 60vh !important;
  max-height: 60vh !important;
  height: 60vh !important;
}

.modal-body.fixed-height .col-header {
  height: 50px;
  max-height: 50px;
}

.modal-body.fixed-height .poc-selection {
  height: 100%;
  max-height: 100%;
}

.modal-body.fixed-height .userlist {
  position: relative;
}

.modal-body.fixed-height .poc-selection .col.userlist > ul {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  max-height: 100%;
  overflow-y: scroll;
}

</style>
